import { normalizeMediaDataUrl } from '@/utils/inspectionDisplay';

/** Resolve receipt entry (string or mobile app { url, type, id }) to a displayable src. */
export function resolveExpenseReceiptSrc(receipt) {
  if (receipt == null) return '';
  if (typeof receipt === 'string') return normalizeMediaDataUrl(receipt);
  if (typeof receipt === 'object') {
    return normalizeMediaDataUrl(
      receipt.url || receipt.data_url || receipt.photo_data || receipt.data,
    );
  }
  return '';
}

export function isPdfReceiptSrc(src) {
  if (!src || typeof src !== 'string') return false;
  const s = src.toLowerCase();
  return s.startsWith('data:application/pdf') || s.includes('application/pdf');
}

/** Prefer API-normalized receipt_items / receipt_urls; fall back to raw receipts[]. */
export function getExpenseReceiptItems(report) {
  if (!report || typeof report !== 'object') return [];

  if (Array.isArray(report.receipt_items) && report.receipt_items.length > 0) {
    return report.receipt_items
      .map((item) => ({
        url: item.url || '',
        type: item.type || '',
        isPdf: Boolean(item.is_pdf) || isPdfReceiptSrc(item.url),
        id: item.id,
      }))
      .filter((item) => item.url);
  }

  if (Array.isArray(report.receipt_urls) && report.receipt_urls.length > 0) {
    return report.receipt_urls.map((url, idx) => {
      const raw = report.receipts?.[idx];
      const type = typeof raw === 'object' ? raw.type : '';
      return { url, type, isPdf: isPdfReceiptSrc(url), id: raw?.id };
    });
  }

  return (report.receipts || [])
    .map((r, idx) => {
      const url = resolveExpenseReceiptSrc(r);
      const type = typeof r === 'object' ? r.type || '' : '';
      return { url, type, isPdf: isPdfReceiptSrc(url), id: typeof r === 'object' ? r.id : undefined };
    })
    .filter((item) => item.url);
}

export function formatExpenseReportDate(report, dateLocale = 'es-ES') {
  const raw = report?.report_date || report?.submitted_at || report?.created_at;
  if (!raw) return null;
  const d = new Date(typeof raw === 'string' ? raw.replace('Z', '') : raw);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleString(dateLocale, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatServiceDateRange(fromVal, toVal, dateLocale = 'es-ES') {
  const fmt = (v) => {
    if (!v) return null;
    const d = new Date(typeof v === 'string' ? v.replace('Z', '') : v);
    if (Number.isNaN(d.getTime())) return null;
    return d.toLocaleDateString(dateLocale, { day: '2-digit', month: 'short', year: 'numeric' });
  };
  const a = fmt(fromVal);
  const b = fmt(toVal);
  if (a && b && a !== b) return `${a} – ${b}`;
  return a || b || null;
}
